'use client'
import { useState, useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'

// Icons
import { Landmark, PencilRuler } from 'lucide-react'

// Components
import BlurImage from '@/components/shared/blur-image'

// Utils
import { cn, placeholderBlurhash } from '@/lib/utils'

// Types
import type { Dictionary } from '@/types/global'

export function HomeMilestone({ dictionary }: { dictionary: Dictionary }) {
  const [ref, isInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  })
  const years = new Date().getFullYear() - 2014
  const targetProjects = 30

  const [displayedYears, setDisplayedYears] = useState(0)
  const [displayedProjects, setDisplayedProjects] = useState(0)

  // Smooth animation using requestAnimationFrame with easing
  useEffect(() => {
    if (isInView) {
      let animationFrameId: number | null = null
      const delay = 300 // delay before animation starts in ms
      const duration = 800 // animation duration in ms
      const startTime = performance.now()

      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime - delay
        if (elapsed < 0) {
          animationFrameId = requestAnimationFrame(animate)
          return
        }
        const progress = Math.min(elapsed / duration, 1)
        // Ease-out quad for smoother animation
        const easedProgress = 1 - Math.pow(1 - progress, 2)

        setDisplayedYears(Math.floor(easedProgress * years))
        setDisplayedProjects(Math.floor(easedProgress * targetProjects))

        if (progress < 1) {
          animationFrameId = requestAnimationFrame(animate)
        }
      }

      animationFrameId = requestAnimationFrame(animate)
      return () => {
        if (animationFrameId) cancelAnimationFrame(animationFrameId)
      }
    }
  }, [isInView, years, targetProjects])

  return (
    <section
      ref={ref}
      id={dictionary.home.milestone.title}
      className="relative h-[200px] overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10">
        {/* {isInView && (
          <video
            className={cn(
              isInView ? 'animate-fade-in' : 'opacity-0',
              'w-full h-auto lg:rounded-xl max-h-[550px] object-cover object-center lgMax:hidden'
            )}
            autoPlay
            muted
            playsInline
            src="/assets/videos/home/milestone.mp4"
          />
        )} */}
        {/* <BlurImage
          src="/assets/images/home/landing-4.png"
          alt="Landing image"
          width={1920}
          height={1080}
          priority={true}
          placeholder="blur"
          className="object-cover w-full h-[200px] "
          blurDataURL={placeholderBlurhash}
        /> */}
      </div>
      <div className="  h-full">
        <div className="z-20 mx-auto grid h-full max-w-7xl items-center md:grid-cols-2 md:justify-items-center md:gap-16  md:py-12">
          <div className="flex items-center gap-2 pl-3 md:pl-0">
            {/* <Landmark className="size-16 md:size-[80px]" /> */}
            <div className="">
              <p className="text-3xl md:text-6xl">{displayedYears}</p>
              <p className="text-xl md:text-2xl">
                {dictionary.home.milestone['milestone-years']}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 pl-3 md:pl-0">
            {/* <PencilRuler className="size-16 md:size-[75px]" /> */}
            <div>
              <p className="text-3xl md:text-6xl">+{displayedProjects}</p>
              <p className="text-xl md:text-2xl">
                {dictionary.home.milestone['milestone-projects']}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
